
const initialstate = {
    condidate:null,
    onecondidate:null,
    viewcondidate:null,
    familyList:null,
    qualicationList:null,
    previousEmpList:null,
    company:null,
    page: 1,
  };
export const NewJoinerReducer = (state = initialstate, { type, payload }) => {
    switch (type) {
      case "GET_NEWJOINER": {
        return {
          ...state,
          loading: false,
          condidate: payload,
        };
      }
      case "GET_SINGEL_DETAILS": {
        return {
          ...state,
          loading: false,
          onecondidate: payload,
        };
      }
      case "VIEW_SINGEL_DETAILS": {
        return {
          ...state,
          loading: false,
          viewcondidate: payload,
        };
      }
      case "GET_NEWJOINER_FAMILY_LIST":{
        return {
          ...state,
          loading:false,
          familyList:payload,
        }
      }
      case "GET_QUALICATION_LIST":{
        return {
          ...state,
          loading:false,
          qualicationList:payload,
        }
      }
      case "GET_COMPANY": {
        return {
          ...state,
          company: payload,
        };
      }
      case "GET_PREVIOUS_EMP_LIST": {
        return {
          ...state,
          loading: false,
          previousEmpList: payload,
        };
      }
      default: {
        return { ...state };
      }
    }
};